import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ButtonComponent } from "../button/button.component";

@Component({
    selector: "rask-icon-button",
    templateUrl: "./icon-button.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./icon-button.component.scss"]
})
export class IconButtonComponent extends ButtonComponent {
}
